// extracted by mini-css-extract-plugin
module.exports = {"bgBackdrop":"style__bgBackdrop__92zTX","bgFrontdrop":"style__bgFrontdrop__KTLtZ","content":"style__content__JbgMY"};